import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import EventCard from "@/components/EventCard";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [params] = useSearchParams();
  const refCode = params.get("ref");

  useEffect(() => {
    api.get("/events").then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14">
      <p className="eyebrow text-[#e0481f] text-sm mb-2">Ride With Us</p>
      <h1 className="headline text-5xl sm:text-6xl text-[#f7f3ec] mb-3">Upcoming Events</h1>
      <p className="text-[#a9a196] mb-10 max-w-2xl">Trail rides, farm-yard parties, highway runs and more. Grab your tickets and roll with the family.</p>
      {refCode && (
        <div className="mb-8 card-warm rounded-xl px-5 py-3 inline-flex items-center gap-2 text-sm">
          <span className="text-[#d4af37] font-display uppercase tracking-wide">Referred by {refCode}</span>
          <span className="text-[#8f857a]">— your purchase supports this Ryder</span>
        </div>
      )}
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {events.map((e) => <EventCard key={e.id} event={e} refCode={refCode} />)}
      </div>
      {events.length === 0 && <p className="text-[#8f857a]">No events posted yet. Check back soon!</p>}
    </div>
  );
}
